import { TrialInterface } from '@galaxy/partner';
import { TrialStatus } from '../core/partner/partner-trial-status';

export function getTrialStatus(trial: TrialInterface): TrialStatus {
  if (trialCancelled(trial)) {
    return TrialStatus.CANCELLED;
  } else if (trialActive(trial)) {
    return TrialStatus.ACTIVE;
  } else if (trialScheduled(trial)) {
    return TrialStatus.SCHEDULED;
  } else if (trialExpired(trial)) {
    return TrialStatus.EXPIRED;
  }
  return null;
}

export function getTrialStatusKey(trial: TrialInterface): string {
  if (trialCancelled(trial)) {
    return 'TRIAL_STATUS.CANCELED';
  } else if (trialActive(trial)) {
    return 'TRIAL_STATUS.ACTIVE';
  } else if (trialScheduled(trial)) {
    return 'TRIAL_STATUS.SCHEDULED';
  } else if (trialExpired(trial)) {
    return 'TRIAL_STATUS.EXPIRED';
  }
  return '';
}

export function trialActive(trial: TrialInterface): boolean {
  const today = new Date();
  return trial.end > today && trial.start <= today;
}

export function trialScheduled(trial: TrialInterface): boolean {
  const today = new Date();
  return trial.end > today;
}

export function trialExpired(trial: TrialInterface): boolean {
  const today = new Date();
  return trial.end <= today;
}

export function trialExpiring(trial: TrialInterface): boolean {
  const today = new Date();
  const diffDays = differenceBetweenDates(today, trial.end);
  return diffDays > 0 && diffDays <= 3;
}

export function trialExpiredOver30DaysAgo(trial: TrialInterface): boolean {
  const today = new Date();
  const diffDays = differenceBetweenDates(trial.end, today);
  return diffDays > 30;
}
export function trialCancelled(trial: TrialInterface): boolean {
  const today = new Date();
  return trial.cancel && trial.cancel <= today && trial.cancel.getTime() > new Date('2000-01-01').getTime();
}

export function differenceBetweenDates(start: Date, end: Date): number {
  if (start && end && start.getTime() < end.getTime()) {
    let diff = 0;
    diff = end.getTime() - start.getTime();
    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    return diffDays;
  }
  return 0;
}

export function convertLocalDateToUTCDate(date: Date): Date {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

export function daysRemaining(start: Date, end: Date): number {
  const currentDate = new Date();
  if (start && end && start.getTime() <= currentDate.getTime()) {
    return differenceBetweenDates(currentDate, end);
  } else {
    return differenceBetweenDates(start, end);
  }
}
